module.exports = "<div class=\"mb\"\n     topbar-user-loading\n     ng-style=\"{'height': vm.height + 'px', 'width': vm.width + 'px', 'margin': vm.margin}\"></div>";


//////////////////
// WEBPACK FOOTER
// ./src/modules/topbar/components/user/components/loading/loading.template.html
// module id = 164
// module chunks = 0